import { css } from 'styled-components';

export const subtitleStyle = css`
  margin-top: 20px;
`;
